/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsAccessibilityWidgetViewProps } from './hosports-accessibility-widget';

export default (props: IHosportsAccessibilityWidgetViewProps) => {
    return (
        <div>{'Accessibility Widget'}</div>
    );
};
